import { Region } from "feiertagejs";
import { GermanState } from "../model/enums/state.enums";
import { environment } from "../../../environments/environment";
import { DialogData } from "../../components/meta/website-config/website-config-form/website-config-form-page-administration/generic-dialog/generic-dialog.component";

export const IMAGE_UPLOAD_TIMEOUT = 60000; // 1 minute
export const DEFAULT_ROOT_FOLDER = 'assets/images';
export const DEFAULT_IMAGE_GALLERY_FOLDER = 'ImageGallery';
export const DEFAULT_IMAGE_GALLERY_FILENAME = 'image_Frei zuschneiden.jpeg';
export const DEFAULT_LOGO_CAROUSEL_FOLDER = 'LogoCarousel';
export const DEFAULT_LOGO_CAROUSEL_FILENAME = 'image_Frei zuschneiden.jpeg';

// Image Gallery Constants (Image Gallery Component) 
export const MIN_IMAGES_IN_GALLERY = 3;
export const MAX_IMAGES_IN_GALLERY = 100;
export const MIN_IMAGES_IN_GALLERY_PREVIEW = 3;
export const MAX_IMAGES_IN_GALLERY_PREVIEW = 10;

// Logo Carousel Constants
export const MIN_LOGOS_IN_CAROUSEL = 3;
export const MAX_LOGOS_IN_CAROUSEL = 50;
export const MIN_LOGOS_IN_CAROUSEL_PREVIEW = 3;
export const MAX_LOGOS_IN_CAROUSEL_PREVIEW = 10;

// 'images'; // Due to multi-project setup, the storage bucket becomes project_id + '-' + STORAGE_BUCKET
export const STORAGE_BUCKET = `${environment.firebaseConfig.projectId}-images`;
export const STORAGE_ROOT_FOLDER = 'https://storage.googleapis.com';

export const DEFAULT_IMAGE_ALT_TEXT = 'Beschreibung des Bildes';

// Google Reviews
export const DEFAULT_GOOGLE_REVIEW_USER_IMAGE = 'assets/images/logo/logo.png';

// MAX FILE SIZE IN MB
export const MAX_FILE_SIZE_IN_MB = 10;

// GENERIC DIALOG DATA
export const MSG_CONFIRM_DELETE_IMAGE: DialogData = {
  title: 'Warnung',
  textChunks: [
    { text: 'Soll diese Bild endgültig gelöscht werden? Nachdem es gelöscht wurde, kann es nicht mehr wiederhergestellt werden' }
  ],
  cancelButtonText: 'Abbrechen',
  confirmButtonText: 'Ja, löschen!',
};



export const MSG_DISALLOW_DELETE_IMAGE_MIN_THRESHOLD: DialogData = {
  title: 'Achtung',
  textChunks: [
    { text: 'Das Löschen des Bildes ist nicht erlaubt, da ' },
    { text: 'mindestens ' + MIN_IMAGES_IN_GALLERY + ' Bilder ', isStrong: true },
    { text: 'in der Galerie vorhanden sein müssen. Bitte laden Sie erst ein weiteres Bild hoch, bevor Sie dieses Bild löschen können.' }
  ],
  cancelButtonText: 'Abbrechen',
  confirmButtonText: 'OK',
};

export const MSG_DISALLOW_DELETE_IMAGE_MIN_THRESHOLD_OF_THUMBNAILS: DialogData = {
  title: 'Achtung',
  textChunks: [
    { text: 'Das Löschen des Bildes ist nicht erlaubt, da ' },
    { text: 'mindestens ' + MIN_IMAGES_IN_GALLERY_PREVIEW + ' Bilder ', isStrong: true },
    { text: 'in der Vorschau vorhanden sein müssen. Bitte bestimmen Sie ein anderes Bild als Vorschaubild, bevor Sie dieses Bild löschen.' }
  ],
  cancelButtonText: 'Abbrechen',
  confirmButtonText: 'OK',
};

export const MSG_DISALLOW_TOGGLE_THUMBNAILS_MIN_THRESHOLDS: DialogData = {
  title: 'Achtung',
  textChunks: [
    { text: 'Das Ändern des Vorschaubildes ist nicht erlaubt, da ' },
    { text: 'mindestens ' + MIN_IMAGES_IN_GALLERY_PREVIEW + ' Bilder ', isStrong: true },
    { text: 'in der Vorschau vorhanden sein müssen. Bitte bestimmen Sie ein anderes Bild als Vorschaubild, bevor Sie dieses Bild aus der Vorschau entfernen können.' }
  ],
  cancelButtonText: 'Abbrechen',
  confirmButtonText: 'OK',
};




// HOLIDAY CONSTANTS & DATA
export const HOLIDAY_NAME_MAP: { [key: string]: string } = {
  NEUJAHRSTAG: "Neujahrstag",
  HEILIGEDREIKOENIGE: "Heilige Drei Könige",
  KARFREITAG: "Karfreitag",
  OSTERSONNTAG: "Ostersonntag",
  OSTERMONTAG: "Ostermontag",
  TAG_DER_ARBEIT: "Tag der Arbeit",
  CHRISTIHIMMELFAHRT: "Christi Himmelfahrt",
  MARIAHIMMELFAHRT: "Mariä Himmelfahrt",
  PFINGSTSONNTAG: "Pfingstsonntag",
  PFINGSTMONTAG: "Pfingstmontag",
  FRONLEICHNAM: "Fronleichnam",
  DEUTSCHEEINHEIT: "Tag der Deutschen Einheit",
  REFORMATIONSTAG: "Reformationstag",
  ALLERHEILIGEN: "Allerheiligen",
  BUBETAG: "Buß- und Bettag",
  ERSTERWEIHNACHTSFEIERTAG: "1. Weihnachtstag",
  ZWEITERWEIHNACHTSFEIERTAG: "2. Weihnachtstag",
  WELTKINDERTAG: "Weltkindertag",
  WELTFRAUENTAG: "Weltfrauentag",
  AUGSBURGER_FRIEDENSFEST: "Augsburger Friedensfest"
};


export const GERMAN_STATE_ABBREVIATION_MAP: Record<GermanState, Region> = {
  [GermanState.BadenWuerttemberg]: "BW",
  [GermanState.Bayern]: "BY",
  [GermanState.Berlin]: "BE",
  [GermanState.Brandenburg]: "BB",
  [GermanState.Bremen]: "HB",
  [GermanState.Hamburg]: "HH",
  [GermanState.Hessen]: "HE",
  [GermanState.Niedersachsen]: "NI",
  [GermanState.MecklenburgVorpommern]: "MV",
  [GermanState.NordrheinWestfalen]: "NW",
  [GermanState.RheinlandPfalz]: "RP",
  [GermanState.Saarland]: "SL",
  [GermanState.Sachsen]: "SN",
  [GermanState.SachsenAnhalt]: "ST",
  [GermanState.SchleswigHolstein]: "SH",
  [GermanState.Thueringen]: "TH",
};